






















import VueOptions from '@utils/VueOptions'

settings =
  name: 'WizardNavbar'

  vue:
    props: ['wizard', 'navigation']

    computed:
      stepsForNavbar: ->
        @wizard.wizardRoutes.filter((step) -> !step.hideOnNavbar)

      activeStepNavbarIndex: ->
        step = @wizard.wizardRoutes.find((step) => step.name is @wizard.activeStep.name)
        step.navbarIndex

    methods:
      hiNavToStep: (step) ->
        @wizard.navToStepName step.name

export default VueOptions.vue settings
